var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 1200 1227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M697.286 531.413 1042.75 130h-81.86L660.919 478.542 421.334 130H145l362.3 527.057L145 1078h81.87l316.776-368.072L796.666 1078H1073L697.266 531.413h.02ZM585.154 661.7l-36.708-52.483-292.077-417.612h125.747l235.709 337.026 36.709 52.483L960.928 1019.2H835.181L585.154 661.72v-.02Z",
    fill: "currentColor"
  })));
};
export default SvgX;